import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ISO_3166_1_CODES } from '@app/modules/authentication/multifactor-authentication/country-codes';
import { RootStoreState, loginStoreActions } from '@app/root-store';
import { AuthService, UserService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import * as loginSelectors from './../../../root-store/login-store/login.selector';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ImageCroppedEvent } from '@app/shared/packages/image-cropper/interfaces';
import { FileUploadService } from '@app/shared/services/file-upload/file-upload.service';
import { LoginStoreService } from '@app/root-store/login-store/login-store.service';
import { AccountSetupNavComponent } from '../account-setup-nav/account-setup-nav.component';
import { MobileSideNavService } from '@app/shared/services/mobile-nav/mobile-nav.service';
//
import moment from 'moment';
import { futureDateValidator, prefixes, stringLocalDateToDatabase, suffixes } from '@app/shared/utils';
import { EVENTS, EventNames } from '@app/constants/events.constants';
import { ChatWidgetService } from '@app/shared/services/chat-widget/chat-widget.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImageCropperComponent } from '@app/shared/packages/image-cropper/component/image-cropper.component';
import { CapitalizeFirstWordPipe } from '@app/shared/pipes/capitalize-first-word.pipe';
import { FilterWorkspacePipe } from '@app/shared/pipes/filter-workspace.pipe';
import { ReuseableDateComponent } from '../date-input/date-input.component';
import { ButtonSlideComponent } from '../button-slide/button-slide.component';
@AutoUnsubscribe()
@Component({
    selector: 'account-setup',
    templateUrl: './account-setup.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatOptionModule,
      MatAutocompleteModule,
      MatIconModule,
      MatTooltipModule,
      MatDividerModule,
      MatCardModule,
      MatProgressSpinnerModule,
      AccountSetupNavComponent,
      ReuseableDateComponent,
      ImageCropperComponent,
      ButtonSlideComponent,
      FilterWorkspacePipe,
      CapitalizeFirstWordPipe
    ]
})
export class AccountSetupComponent implements OnInit, OnDestroy {
  @Input() accountType;
  @Output() closeAccountSetupSideBarEventEmitter = new EventEmitter();
  @ViewChild('AccountSetupNavChildComponent') accountSetupNavComponent: AccountSetupNavComponent;
  @ViewChild('streetAddressInput', { static: false }) streetAddressInput: ElementRef;

  user$;
  sideNavList;
  userProfile;
  tick = 1000;
  CityData = [];
  StateData = [];
  nextStep = '';
  format = null;
  counter = 1800;
  moment = moment;
  showdiv = false;
  currentStep = '';
  previousStep = '';
  stateData2 = [];
  countryData = [];
  errCode$ = false;
  loginStateObject;
  croppedImage: any;
  videoMimeType: any;
  canvasRotation = 0;
  showLoader = false;
  screenWidth: number;
  currentActiveElement;
  showCropper = false;
  codeSubmitted = false;
  verification_code_Data;
  currentActiveIndex = 0;
  switchFromUser = false;
  todayDate = new Date();
  apiIsInprogress = false;
  filteredCountryCodes = [];
  isCityDataLoading = false;
  isStateDataLoading = false;
  hiddenPhoneNumber = '*****';
  imageUploadedSuccess = false;
  isCountryDataLoading = false;
  imageChangedEvent: any = '';
  searchStringCode: FormControl;
  searchStringState: FormControl;
  locationSettingForm: FormGroup;
  searchStringCountry: FormControl;
  countryCodes = ISO_3166_1_CODES;
  containWithinAspectRatio = false;
  isAccountMarkedCompleted = false;
  resizeObservable$: Observable<Event>;
  userBasictInformationForm: FormGroup;
  userContactInformationForm: FormGroup;
  changedlocationSettingFields: any = {};
  changedBasicInformationFields: any = {};
  changedContactInformationFields: any = {};
  subscription: Subscription = new Subscription();
  steps = [
    // { name: 'Instructions', completed: false, status: 'inactive', icon: '' },
    { name: 'Basic Information', completed: false, status: 'inactive', icon: 'basic_information' },
    { name: 'Contact Information', completed: false, status: 'inactive', icon: 'contact_information' },
    { name: 'Location Settings', completed: false, status: 'inactive', icon: 'location_setting' },
    { name: 'Profile Picture', completed: false, status: 'inactive', icon: 'profile_picture' },
    { name: 'Account Set Up Status', completed: false, status: 'inactive', icon: '' },
  ];
  hasUnsavedChanges: boolean;
  get birthDate() {
    return this.userBasictInformationForm.controls['birthdate'].value;
  }
  prefixes = prefixes;
  suffixes = suffixes;
  genderHasValue = signal(false);

  constructor(
    public zone: NgZone,
    private store: Store,
    private _fb: FormBuilder,
    private toastr: ToastrService,
    private _userService: UserService,
    private loginService: LoginStoreService,
    private store$: Store<RootStoreState.State>,
    private fileUploadService: FileUploadService,
    private mobileNavService: MobileSideNavService,
    private _cd: ChangeDetectorRef,
    private chatWidgetService: ChatWidgetService,
    private authService: AuthService
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe(async (state) => {
        this.loginStateObject = state.data;
        const authUser = this.authService.user;
        if (this.loginStateObject?.switch_from_user_id && this.loginStateObject?.id != authUser['id']) {
          this.switchFromUser = this.loginStateObject?.switchFromUser;
        } else {
          this.switchFromUser = null;
        }
        this.checkCompletedSteps();
        this._cd.markForCheck();
      })
    );
    this.userProfile = this.loginStateObject.profile_image_url;
    if (this.loginStateObject.profile_image_url) {
      this.imageUploadedSuccess = true;
    }
  }

  ngOnInit(): void {
    this.setStatusForSidenavMenu(0);
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.store$.dispatch(new loginStoreActions.LoginRequestAction());
    this.user$ = this.store.select(loginSelectors.getCurrentUserDetailsAll);

    this.searchStringCountry = new FormControl();
    this.searchStringState = new FormControl();
    this.searchStringCode = new FormControl();

    this.userBasictInformationForm = this._fb.group({
      first_name: ['', [Validators.required]],
      middle_name: ['', []],
      last_name: ['', [Validators.required]],
      your_self: ['', []],
      birthdate: ['', [futureDateValidator]],
      gender: ['', []],
      prefix: [''],
      suffix: [''],
    });

    this.userContactInformationForm = this._fb.group({
      country: ['', [Validators.maxLength(100)]],
      state: ['', [Validators.maxLength(100)]],
      zip: ['', []],
      city: ['', [Validators.maxLength(100)]],
      street: ['', [Validators.maxLength(100)]],
      phone_no: ['', [Validators.maxLength(15)]],
      contact_email: ['', [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,25}$')]],
    });

    this.locationSettingForm = this._fb.group({
      residence_state: ['', [Validators.maxLength(100)]],
      residence_country: ['', [Validators.required, Validators.maxLength(100)]],
    });

    this.subscription.add(
      this.user$.subscribe((user) => {
        this.userContactInformationForm.get('country').setValue(user.country ?? '');
        this.userContactInformationForm.get('state').setValue(user.state ?? '');
      })
    );

    this.trackFormChanges();
    this.getAllCountries();
    this.getStatesByCountryCode('US', true);
  }

  trackFormChanges() {
    // Track Basic Information Form Changes
    this.trackFieldChanges(this.userBasictInformationForm, this.changedBasicInformationFields, 'basic');

    // Track Contact Information Form Changes
    this.trackFieldChanges(this.userContactInformationForm, this.changedContactInformationFields, 'contact');

    // Track Location Settings Form Changes
    this.trackFieldChanges(this.locationSettingForm, this.changedlocationSettingFields, 'location');
  }

  trackFieldChanges(form: FormGroup, changedFields: any, formType: 'basic' | 'contact' | 'location') {
    Object.keys(form.controls).forEach((field) => {
      const control = form.get(field);

      if (control) {
        // Track changes on focusout or selectChange events for each control
        this.subscription.add(
          control.valueChanges
            .pipe(
              debounceTime(500), // Wait before triggering update
              distinctUntilChanged() // Prevent unnecessary calls
            )
            .subscribe(() => {
              if (control.dirty && control.value !== null && control.value !== undefined) {
                changedFields[field] = control.value;

                // If there are changes, update the user with the corresponding form type
                if (Object.keys(changedFields).length > 0) {
                  // this.updateUser(formType);
                }
              }
            })
        );
      }
    });
  }

  // ngAfterViewInit() {
  //   // const firstßIncompleteIndex = this.findFirstIncompleteIndex();
  //   this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_instruction_start }]);
  //   this._userService
  //     .loadGoogleMapsApi()
  //     .then(() => {})
  //     .catch((error) => console.error('Error loading Google Maps API:', error));
  // }

  ngAfterViewInit() {
    if (!!this.userBasictInformationForm?.controls['gender']) {
      this.subscription.add(
        this.userBasictInformationForm.controls['gender'].valueChanges.subscribe((value) => {
          this.genderHasValue.set(!!value);
        })
      );
    }
    this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_instruction_start }]);
  }

  async getAllCountries() {
    this.isCountryDataLoading = true;
    this.subscription.add(
      (await this._userService.getCountriesData()).subscribe(
        (response) => {
          this.countryData = response.sort((a, b) => (a.isoCode === 'US' ? -1 : 0));
          this.isCountryDataLoading = false;
          this._cd.detectChanges();
        },
        (error: any) => {
          this.isCountryDataLoading = false;
          this.toastr.error('Error occurred while getting a list of countries');
        }
      )
    );
  }
  async getStatesByCountryCode(countryCode, residenceInfo = false) {
    this.isStateDataLoading = true;
    this.subscription.add(
      (await this._userService.getStatesByCountryCode(countryCode)).subscribe(
        (response) => {
          if (residenceInfo) {
            this.stateData2 = [...response];
          }
          if (!residenceInfo) {
            this.StateData = [...response];
          }
          this.isStateDataLoading = false;
          this._cd.detectChanges();
        },
        (error: any) => {
          this.isStateDataLoading = false;
          this.toastr.error('Error occurred while getting a list of states');
        }
      )
    );
  }

  async getCountriesDataByCountryAndStateCode(countryCode, stateCode) {
    this.isCityDataLoading = true;
    this.subscription.add(
      (await this._userService.getCountriesDataByCountryAndStateCode(countryCode, stateCode)).subscribe(
        (response) => {
          this.CityData = [...response];
          this.isCityDataLoading = false;
          this._cd.detectChanges();
        },
        (error: any) => {
          this.isCityDataLoading = false;
          this.toastr.error('Error occurred while getting a list of cities');
        }
      )
    );
  }


  trackEventsInMixPanel(events: { eventName: EventNames; data?: any }[]) {
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }
  updateUser(formType: 'basic' | 'contact' | 'location') {
    let requestData = null;

    if (formType === 'basic' && Object.keys(this.changedBasicInformationFields).length > 0) {
      const birthdate: Date = this.userBasictInformationForm.get('birthdate').value;
      const formattedDate = birthdate ? stringLocalDateToDatabase(birthdate) : null;

      requestData = {
        ...this.changedBasicInformationFields,
        birthdate: formattedDate,
      };
    }

    if (formType === 'contact' && Object.keys(this.changedContactInformationFields).length > 0) {
      requestData = { ...this.changedContactInformationFields };
    }

    if (formType === 'location' && Object.keys(this.changedlocationSettingFields).length > 0) {
      requestData = { ...this.changedlocationSettingFields };
    }

    if (requestData) {
      this.subscription.add(
        this._userService.updateUser(requestData).subscribe(() => {
          this.resetChangedFields(formType);
        })
      );
    }
  }
  handleFieldChange(event: any, fieldName: string, formType: 'basic' | 'contact' | 'location') {
    const control = this.getFormGroup(formType).get(fieldName);

    if (control && control.dirty) {
      // Add the changed field to track it
      if (formType === 'basic') {
        this.changedBasicInformationFields[fieldName] = control.value;
      } else if (formType === 'contact') {
        this.changedContactInformationFields[fieldName] = control.value;
      } else if (formType === 'location') {
        this.changedlocationSettingFields[fieldName] = control.value;
      }

      // Call the update user method
      this.updateUser(formType);
    }
  }

  getFormGroup(formType: 'basic' | 'contact' | 'location'): FormGroup {
    switch (formType) {
      case 'basic':
        return this.userBasictInformationForm;
      case 'contact':
        return this.userContactInformationForm;
      case 'location':
        return this.locationSettingForm;
      default:
        throw new Error('Invalid form type');
    }
  }

  resetChangedFields(formType: 'basic' | 'contact' | 'location') {
    if (formType === 'basic') {
      this.changedBasicInformationFields = {};
    }
    if (formType === 'contact') {
      this.changedContactInformationFields = {};
    }
    if (formType === 'location') {
      this.changedlocationSettingFields = {};
    }
  }
  updateUserBasicInformation() {
    const form = this.userBasictInformationForm;
    form.get('first_name').setValidators([Validators.required]);
    form.get('last_name').setValidators([Validators.required]);
    form.get('first_name').updateValueAndValidity();
    form.get('last_name').updateValueAndValidity();
    if (!this.userBasictInformationForm.valid) {
      return;
    }
    const birthdate: Date = form.get('birthdate').value;
    const formattedDate = birthdate ? stringLocalDateToDatabase(birthdate) : null;
    const request = {
      first_name: form.controls['first_name'].value || null,
      middle_name: form.controls['middle_name'].value || null,
      last_name: form.controls['last_name'].value || null,
      your_self: form.controls['your_self'].value || null,
      birthdate: formattedDate,
      gender: form.controls['gender'].value || null,
      prefix: form.controls['prefix'].value || null,
      suffix: form.controls['suffix'].value || null,
    };
    if (Object.keys(this.changedBasicInformationFields).length > 0) {
      this.apiIsInprogress = true;
      this.subscription.add(
        this._userService.updateUser(request).subscribe(
          (res) => {
            this.apiIsInprogress = false;
            this.toastr.success('Basic information Set Up');
            this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_basic_information_change }]);
            // this.showNextStep();
            Object.keys(this.changedBasicInformationFields).forEach((key) => delete this.changedBasicInformationFields[key]);
            this.userBasictInformationForm.reset();
            this.store$.dispatch(new loginStoreActions.LoginRequestAction());
            // this.subscription.add(
            //   this.user$.subscribe((user) => {
            //     if (user.first_name && user.middle_name && user.last_name && user.your_self && user.birthdate && user.gender) {
            //       this.steps[1].completed = true;
            //     }
            //   })
            // );
          },
          (error) => {
            this.apiIsInprogress = false;
          }
        )
      );
    } else {
      this.showNextStep();
    }
    this._cd.detectChanges();
  }

  updateUserContactInformation() {
    let registeredCountry = false;
    const form = this.userContactInformationForm;
    form.get('state').setValidators([Validators.maxLength(100)]);
    form.get('city').setValidators([Validators.maxLength(100)]);
    form.get('country').setValidators([Validators.maxLength(100)]);
    form.get('street').setValidators([Validators.maxLength(100)]);
    form.get('contact_email').setValidators([Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,25}$')]);

    form.get('state').updateValueAndValidity();
    form.get('city').updateValueAndValidity();
    form.get('country').updateValueAndValidity();
    form.get('street').updateValueAndValidity();
    form.get('contact_email').updateValueAndValidity();

    if (form.get('phone_no').value) {
      form.get('phone_no').setValidators([Validators.maxLength(15)]);
      form.get('phone_no').updateValueAndValidity();
    }
    if (this.countryData.length) {
      registeredCountry = this.countryData.find((element) => {
        if (form.get('country').value && element.name.trim().toLowerCase() == form.get('country').value.trim().toLowerCase()) {
          form.get('country').patchValue(element.name.trim());
          return true;
        }
        return false;
      });
      if (!registeredCountry && form.get('country').value) {
        form.controls['country'].markAsTouched();
        form.controls['country'].setErrors({});
      }
    }
    if (!this.userContactInformationForm.valid) {
      return;
    }

    const request = {
      contact_email: this.userContactInformationForm.controls['contact_email'].value || null,
      phone_no: this.userContactInformationForm.controls['phone_no'].value || null,
      state: this.userContactInformationForm.controls['state'].value || null,
      city: this.userContactInformationForm.controls['city'].value || null,
      street: this.userContactInformationForm.controls['street'].value || null,
      zip: this.userContactInformationForm.controls['zip'].value || null,
      country: this.userContactInformationForm.controls['country'].value || null,
    };
    if (Object.keys(this.changedContactInformationFields).length > 0) {
      this.subscription.add(
        this._userService.updateUser(request).subscribe(
          (data) => {
            this.toastr.success('Contact information Set Up');
            this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_contact_information_change }]);
            // this.showNextStep();
            Object.keys(this.changedContactInformationFields).forEach((key) => delete this.changedContactInformationFields[key]);
            this.userContactInformationForm.reset();
            this.store$.dispatch(new loginStoreActions.LoginRequestAction());
            // this.subscription.add(
            //   this.user$.subscribe((user) => {
            //     if (user.city && user.country && user.contact_email && user.phone_no && user.street && user.state && user.zip) {
            //       this.steps[2].completed = true;
            //     }
            //   })
            // );
          },
          (error: any) => {
            this.toastr.error(error.error.message);
          }
        )
      );
    } else {
      this.showNextStep();
    }
    this._cd.detectChanges();
  }

  setLegalResidence() {
    let registeredCountry = false;
    const form = this.locationSettingForm;
    form.get('residence_country').setValidators([Validators.required]);
    form.get('residence_state').setValidators([Validators.maxLength(100)]);
    form.get('residence_country').setValidators([Validators.maxLength(100)]);
    form.get('residence_country').updateValueAndValidity();
    form.get('residence_state').updateValueAndValidity();

    if (this.countryData.length) {
      registeredCountry = this.countryData.find((element) => {
        if (form.get('residence_country').value && element.name.trim().toLowerCase() == form.get('residence_country').value.trim().toLowerCase()) {
          form.get('residence_country').patchValue(element.name.trim());
          return true;
        }
        return false;
      });
      if (!registeredCountry && form.get('residence_country').value) {
        form.controls['residence_country'].markAsTouched();
        form.controls['residence_country'].setErrors({});
      }
    }
    if (!this.locationSettingForm.valid) {
      return;
    }
    const dataObj = {
      residence_country: this.locationSettingForm.value.residence_country,
      residence_state: this.locationSettingForm.value.residence_state ? this.locationSettingForm.value.residence_state : null,
    };
    if (
      Object.keys(this.changedlocationSettingFields).length > 0 &&
      dataObj.residence_country &&
      (dataObj.residence_country !== 'United States' || (dataObj.residence_country == 'United States' && dataObj.residence_state))
    ) {
      this.apiIsInprogress = true;
      this.subscription.add(
        this._userService.updateUser(dataObj).subscribe(
          (res) => {
            this.apiIsInprogress = false;
            this.toastr.success('Location Setting Set Up');
            this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_location_change }]);
            // this.steps[3].completed = true;
            // this.showNextStep();
            Object.keys(this.changedlocationSettingFields).forEach((key) => delete this.changedlocationSettingFields[key]);
            this.locationSettingForm.reset();
            this.store$.dispatch(new loginStoreActions.LoginRequestAction());
            this._cd.detectChanges();
          },
          (error) => {
            this.apiIsInprogress = false;
            this._cd.detectChanges();
          }
        )
      );
    } else {
      this.showNextStep();
    }
  }

  async updateProfilePic(input) {
    this.subscription.add(
      this.fileUploadService.profilePic(input).subscribe(
        (data: any) => {
          this.store$.dispatch(new loginStoreActions.LoginRequestAction());
          this.subscription.add(
            this.loginService.loginObject.subscribe(async (state) => {
              this.loginStateObject = state.data;
              this.userProfile = this.loginStateObject.profile_image_url;
              setTimeout(() => {
                this.showLoader = false;
                this.showdiv = false;
                this.imageUploadedSuccess = true;
                this.format = '';
              }, 1000);
            })
          );
        },
        (error: any) => {}
      )
    );
  }

  setProfilePicture() {
    if (this.croppedImage || this.format) {
      this.showLoader = true;
      const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
      fileUpload.value = '';
      this.uploadFile(fileUpload);
    } else {
      this.showNextStep();
    }
  }

  uploadFile(file) {
    const fd = {
      file: this.croppedImage,
      type: this.format,
    };
    this.updateProfilePic(fd);
  }

  fileChangeEvent(event: any): void {
    const file = event.target.files && event.target.files[0];
    if (file) {
      if (file.type.indexOf('image') > -1) {
        this.format = 'image';
        this.showdiv = true;
        this.imageChangedEvent = event;
        this._cd.markForCheck();
      } else if (file.type.indexOf('video') > -1) {
        this.toastr.error('Please upload a JPEG or PNG less than 10MB');
        // this.format = 'video';
        // this.videoMimeType = file.type;
        // var reader = new FileReader();
        // reader.readAsDataURL(event.target.files[0]);
        // reader.onload = (file) => {
        //   this.croppedImage = reader.result;
        //   this.cd.markForCheck();
        // };
      }
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.setProfilePicture();
  }

  imageLoaded() {
    this.showCropper = true;
  }

  setStatusForSidenavMenu(activeIndex) {
    if (activeIndex != -1) {
      for (let i = 0; i < this.steps.length; i++) {
        if (i === activeIndex) {
          this.steps[i].status = 'active';
          this.currentActiveElement = this.steps[i];
        } else {
          this.steps[i].status = 'inactive';
        }
      }
      this.currentActiveIndex = activeIndex;
      this.currentStep = this.currentActiveElement.name;
    } else {
      this.currentActiveElement = undefined;
      this.currentActiveIndex = undefined;
      this.currentStep = undefined;
      for (const step of this.steps) {
        step.status = 'inactive';
      }
    }

    this._cd.detectChanges();
  }

  findFirstIncompleteIndex() {
    for (let i = 0; i < this.steps.length; i++) {
      if (!this.steps[i].completed) {
        return i;
      }
    }
    return -1;
  }

  checkCompletedSteps() {
    // if (
    //   this.loginStateObject.first_name &&
    //   this.loginStateObject.middle_name &&
    //   this.loginStateObject.last_name &&
    //   this.loginStateObject.your_self &&
    //   this.loginStateObject.gender &&
    //   this.loginStateObject.birthdate
    // ) {
    //   this.steps[1].completed = true;
    // }
    // if (
    //   this.loginStateObject.city &&
    //   this.loginStateObject.country &&
    //   this.loginStateObject.contact_email &&
    //   this.loginStateObject.phone_no &&
    //   this.loginStateObject.street &&
    //   this.loginStateObject.state &&
    //   this.loginStateObject.zip
    // ) {
    //   this.steps[2].completed = true;
    // }
    // if (this.loginStateObject.residence_country) {
    //   this.steps[3].completed = true;
    // }
    // if (this.loginStateObject.profile_image_url) {
    //   this.steps[4].completed = true;
    // }
  }

  markAllAsComplete() {
    const inputObj = {
      account_setup_status: 'complete',
    };
    this.subscription.add(
      this._userService.updateUser(inputObj).subscribe(
        () => {
          this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_status_complete }]);
          this.store$.dispatch(new loginStoreActions.LoginRequestAction());
          this.closeSideNav();
        },
        () => {
          this.apiIsInprogress = false;
          this._cd.detectChanges();
        }
      )
    );
  }

  submitAllFormAnswers(event: string | undefined) {
    this.isAccountMarkedCompleted = !!event;
    if (!!event) {
      this.markAllAsComplete();
    }
  }

  menuSelectionEventhandler(event) {
    switch (event) {
      case 0:
        if (!this.steps[0].completed) {
          this.setStatusForSidenavMenu(0);
        }
        break;
      case 1:
        if (!this.steps[1].completed) {
          this.setStatusForSidenavMenu(1);
        }
        break;
      case 2:
        if (!this.steps[2].completed) {
          this.setStatusForSidenavMenu(2);
        }
        break;
      case 3:
        if (!this.steps[3].completed) {
          this.setStatusForSidenavMenu(3);
        }
        break;
      // case 4:
      //   if (!this.steps[4].completed) {
      //     this.setStatusForSidenavMenu(4);
      //   }
      //   break;
    }
  }

  updateStep() {
    // if (this.currentStep == 'Instructions') {
    //   this.showNextStep();
    // } else
    if (this.currentStep == 'Basic Information') {
      this.updateUserBasicInformation();
    } else if (this.currentStep == 'Contact Information') {
      this.updateUserContactInformation();
    } else if (this.currentStep == 'Location Settings') {
      this.setLegalResidence();
    }
  }

  showNextStep() {
    const activeIndex = this.steps.findIndex((item) => item.status == 'active');
    if (activeIndex == -1) {
      return;
    }
    for (let i = activeIndex + 1; i < this.steps.length; i++) {
      if (!this.steps[i].completed) {
        this.steps[i].status = 'active';
        this.nextStep = this.steps[i].name;
        break;
      }
    }
    if (!this.nextStep || this.nextStep == '') {
      return;
    }
    if (this.nextStep == 'Basic Information') {
      this.setStatusForSidenavMenu(0);
      this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_instruction_end }, { eventName: EVENTS.account_setup_basic_information_start }]);
    } else if (this.nextStep == 'Contact Information') {
      this.setStatusForSidenavMenu(1);
      this.trackEventsInMixPanel([
        { eventName: EVENTS.account_setup_basic_information_end },
        { eventName: EVENTS.account_setup_contact_information_start },
      ]);
    } else if (this.nextStep == 'Location Settings') {
      this.setStatusForSidenavMenu(2);
      this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_contact_information_end }, { eventName: EVENTS.account_setup_location_start }]);
    } else if (this.nextStep == 'Profile Picture') {
      this.setStatusForSidenavMenu(3);
      this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_location_end }, { eventName: EVENTS.account_setup_profile_start }]);
    } else if (this.nextStep == 'Account Set Up Status') {
      this.setStatusForSidenavMenu(4);
      this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_profile_end }]);
    }
    this._cd.markForCheck();
  }

  showPreviousStep() {
    const activeIndex = this.steps.findIndex((item) => item.status == 'active');
    if (activeIndex == -1) {
      return;
    }
    for (let i = activeIndex - 1; i >= 0; i--) {
      if (!this.steps[i].completed) {
        this.steps[i].status = 'active';
        this.previousStep = this.steps[i].name;
        break;
      }
    }
    if (!this.previousStep || this.previousStep == '') {
      return;
    }
    // if (this.previousStep == 'Instructions') {
    //   this.setStatusForSidenavMenu(0);
    //   this.accountSetupNavComponent.menuSelectEvent(0);
    // } else

    if (this.previousStep == 'Basic Information') {
      this.setStatusForSidenavMenu(0);
      this.accountSetupNavComponent.menuSelectEvent(0);
    } else if (this.previousStep == 'Contact Information') {
      this.setStatusForSidenavMenu(1);
      this.accountSetupNavComponent.menuSelectEvent(2);
    } else if (this.previousStep == 'Location Settings') {
      this.setStatusForSidenavMenu(2);
      this.accountSetupNavComponent.menuSelectEvent(3);
    } else if (this.previousStep == 'Profile Picture') {
      this.setStatusForSidenavMenu(3);
      this.accountSetupNavComponent.menuSelectEvent(4);
    }
  }

  async selectEvent(itemSelected, countrycode?: string, stateCode?: string) {
    if (itemSelected.source._selected) {
      if (countrycode && stateCode) {
        this.CityData = [];
        this.userContactInformationForm.get('city')?.setValue('');
        // this.userContactInformationForm.controls['state'].setValue(itemSelected.source.value);
        this.getCountriesDataByCountryAndStateCode(countrycode, stateCode);
      } else if (countrycode) {
        this.StateData = [];
        this.CityData = [];
        this.userContactInformationForm.get('state')?.setValue('');
        this.userContactInformationForm.get('city')?.setValue('');
        this.userContactInformationForm.get('street')?.setValue('');
        this.userContactInformationForm.get('zip')?.setValue('');
        // this.userContactInformationForm.controls['country'].setValue(itemSelected.source.value);
        this.getStatesByCountryCode(countrycode);
      }
    }
  }

  copyDataFromContactInfo() {
    const countryInfo = this.userContactInformationForm.controls['country']?.value;
    const stateInfo = this.userContactInformationForm.controls['state']?.value;
    if (countryInfo) {
      this.locationSettingForm.get('residence_country').setValue(countryInfo);
      this.handleCountryResidenceSelection(countryInfo);
      this.locationSettingForm.get('residence_country').markAsDirty();
      if (stateInfo) {
        this.locationSettingForm.get('residence_state').setValue(countryInfo === 'United States' ? stateInfo : '');
        this.locationSettingForm.get('residence_state').markAsDirty();
      }
    }
  }

  async handleCountryResidenceSelection(selectedCountry) {
    if (this.locationSettingForm.get('residence_country').value && selectedCountry == 'United States') {
      this.locationSettingForm.get('residence_state').setValidators([Validators.required]);
    } else {
      this.locationSettingForm.get('residence_state')?.clearValidators();
    }
    this.locationSettingForm.get('residence_state').updateValueAndValidity();
    this._cd.detectChanges();
  }

  handleSidenavMenuNavigation(index: number) {
    if (index !== this.currentActiveIndex) {
      this.saveCurrentStepData(); // Save current tab's data before switching
      this.setStatusForSidenavMenu(index); // Then, update the active step
    }
  }
  saveCurrentStepData() {
    if (!this.currentStep) {
      return;
    }
    if (this.currentStep === 'Basic Information') {
      this.updateUserBasicInformation();
    } else if (this.currentStep === 'Contact Information') {
      this.updateUserContactInformation();
    } else if (this.currentStep === 'Location Settings') {
      this.setLegalResidence();
    }
  }

  handleDateChange(value) {
    const birthdateControl = this.userBasictInformationForm.controls['birthdate'];
    birthdateControl.setValue(value);
    birthdateControl.markAsTouched();
    birthdateControl.markAsDirty();
    birthdateControl.updateValueAndValidity();
    this._cd.detectChanges();
    this.updateUser('basic');
  }
  closeSideNav() {
    this.trackEventsInMixPanel([{ eventName: EVENTS.account_setup_close }]);
    // this.sidenav.close();
    this.closeAccountSetupSideBarEventEmitter.emit(false);
    this.mobileNavService.handleAccountSetupSidenav(false);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this._userService.cleanupWorker();
  }
  isDragOver: boolean = false;

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(): void {
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    const { files } = event.dataTransfer;

    if (files) {
      if (files[0].type.indexOf('image') > -1) {
        this.format = 'image';
        this.showdiv = true;
        this.imageChangedEvent = {
          target: {
            files,
          },
        };
        this._cd.markForCheck();
      } else if (files[0].type.indexOf('video') > -1) {
        this.toastr.error('Please upload a JPEG or PNG less than 10MB');
      }
    }
  }
}
